export const DEFAULT_WIKI_REPO_SYNC_PATH = '.cubic/wiki';

const DENIED_PREFIXES = ['.git/', '.github/workflows/'] as const;

export type RepoSyncPathValidationResult =
  | { success: true; path: string }
  | { success: false; error: string };

export function normalizeRepoSyncPath(input: string): RepoSyncPathValidationResult {
  const trimmed = input.trim().replace(/\\/g, '/').replace(/\/+$/g, '');

  if (!trimmed) {
    return { success: false, error: 'Path cannot be empty' };
  }

  if (trimmed.startsWith('/')) {
    return { success: false, error: 'Path must be relative' };
  }

  if (trimmed === '.' || trimmed === '..') {
    return { success: false, error: 'Path cannot be the repository root' };
  }

  const segments = trimmed.split('/').filter(Boolean);
  if (segments.length === 0) {
    return { success: false, error: 'Path cannot be the repository root' };
  }

  if (segments.some((segment) => segment === '.' || segment === '..')) {
    return { success: false, error: 'Path cannot contain . or .. segments' };
  }

  if (trimmed.length > 255) {
    return { success: false, error: 'Path must be 255 characters or fewer' };
  }

  if (segments.length > 8) {
    return { success: false, error: 'Path is too deeply nested' };
  }

  const normalizedWithSlash = `${trimmed}/`;
  const deniedPrefix = DENIED_PREFIXES.find((prefix) => normalizedWithSlash.startsWith(prefix));
  if (deniedPrefix) {
    return { success: false, error: `Path cannot be under ${deniedPrefix}` };
  }

  return { success: true, path: trimmed };
}
